export default __webpack_public_path__ + "static/media/wordpress.9a8f7e6f.svg";